import React, { useEffect, useReducer } from "react"
import { AIDemoForm } from "./AIDemoForm"
import { AIResults } from "./AIResults"
import { Button, Flex, Heading } from "@chakra-ui/react"
import { NumberOfTries } from "../types/types"
import {
  testingCompanyDescription,
  testingProjectDescription,
} from "../constants/constants"
import {
  bookDemoMessage,
  freeTrialLink,
  reachedMaxNumberOfTriesMessage,
} from "../constants/texts"
import { numberOfTriesReducer } from "../reducers/numberOfTriesReducer"

export const AIDemo = () => {
  const [showResults, setShowResults] = React.useState<boolean>(false)
  const [projectDescription, setProjectDescription] = React.useState<string>(
    testingProjectDescription
  )
  const [companyDescription, setCompanyDescription] = React.useState<string>(
    testingCompanyDescription
  )
  const maxNumberOfTries = window.DMAZE.appConfig.maxNumberOfTries
  const restrictionExpiresIn = window.DMAZE.appConfig.restrictionExpiresIn
  const initNumberOfTries = (): NumberOfTries => {
    const numberOfTries = localStorage.getItem("numberOfTries")
    if (numberOfTries) {
      if (
        Date.now() - JSON.parse(numberOfTries).timestamp >
        restrictionExpiresIn
      ) {
        return { count: 0, timestamp: Date.now() }
      }
      return JSON.parse(numberOfTries)
    } else {
      return { count: 0, timestamp: Date.now() }
    }
  }

  const isRestricted = () => {
    return (
      numberOfTries.count >= maxNumberOfTries &&
      Date.now() - numberOfTries.timestamp < restrictionExpiresIn
    )
  }

  const [numberOfTries, dispatchNumberOfTries] = useReducer(
    numberOfTriesReducer,
    initNumberOfTries()
  )

  useEffect(() => {
    localStorage.setItem("numberOfTries", JSON.stringify(numberOfTries))
  }, [numberOfTries])

  const handleTryAgain = () => {
    setShowResults(false)
  }

  return (
    <Flex w="60%" direction="column" align="center">
      {!showResults && !isRestricted() && (
        <AIDemoForm
          maxNumberOfTries={maxNumberOfTries}
          showResults={showResults}
          setShowResults={setShowResults}
          companyDescription={companyDescription}
          projectDescription={projectDescription}
          setProjectDescription={setProjectDescription}
          setCompanyDescription={setCompanyDescription}
        />
      )}
      {showResults && !isRestricted() && (
        <AIResults
          handleTryAgain={handleTryAgain}
          companyDescription={companyDescription}
          projectDescription={projectDescription}
          dispatchNumberOfTries={dispatchNumberOfTries}
        />
      )}
      {isRestricted() && (
        <Flex direction="column" align="center">
          <Heading marginBottom="32px" color="dmazespecial.400" as="h2">
            {reachedMaxNumberOfTriesMessage}
          </Heading>

          <Button onClick={() => (window.location.href = freeTrialLink)}>
            {bookDemoMessage}
          </Button>
        </Flex>
      )}
    </Flex>
  )
}
